export default function AppSection() {
  return (
    <section id="app" className="w-full bg-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-[900px] mx-auto">
          <div className="text-center mb-10">
            <p className="text-xs md:text-sm font-medium text-accent-500 uppercase tracking-wide mb-2">移动端体验</p>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">移动端体验</h2>
            <p className="mt-2 text-sm text-foreground-500">随时随地，追剧不断</p>
          </div>

          <div className="flex flex-col lg:flex-row items-center gap-8 bg-gradient-to-br from-primary-500 via-primary-500 to-accent-500 rounded-2xl p-8 md:p-12">
            <div className="flex-1 text-center lg:text-left">
              <h3 className="text-xl md:text-2xl font-bold font-heading text-background-50 mb-3">
                糖心视频 APP
              </h3>
              <p className="text-sm md:text-base text-background-50/85 leading-relaxed mb-4">
                专为移动端优化的观影体验。支持画中画播放、倍速调整、夜间模式、离线缓存等实用功能。聚合西瓜视频、樱花视频、糖豆视频、樱桃视频等平台资源，一部手机看遍全网热播。
              </p>
              <div className="flex flex-wrap items-center gap-2 justify-center lg:justify-start">
                {['画中画播放', '倍速调整', '夜间模式', '离线缓存', '智能推荐', '多线路切换'].map((feat) => (
                  <span key={feat} className="px-3 py-1 rounded-full bg-background-50/20 text-background-50 text-xs font-medium whitespace-nowrap">
                    <i className="ri-check-line mr-1"></i>{feat}
                  </span>
                ))}
              </div>
              <div className="mt-6 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
                <a href="#app" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-50 text-primary-600 font-medium text-sm hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap">
                  <i className="ri-apple-line text-lg"></i>
                  iOS 下载
                </a>
                <a href="#app" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-50/20 text-background-50 font-medium text-sm border border-background-50/30 hover:bg-background-50/30 transition-colors cursor-pointer whitespace-nowrap">
                  <i className="ri-android-line text-lg"></i>
                  Android 下载
                </a>
              </div>
            </div>

            <div className="w-[240px] md:w-[280px] shrink-0">
              <div className="relative w-full aspect-[9/16] rounded-2xl overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20displaying%20a%20video%20streaming%20app%20interface%20with%20movie%20posters%20grid%20layout%2C%20dark%20theme%20UI%20with%20warm%20accent%20colors%2C%20floating%20on%20a%20clean%20minimal%20background%2C%20premium%20app%20presentation%20style%2C%20soft%20glow%20effect&width=560&height=996&seq=app-phone-mockup&orientation=portrait"
                  alt="糖心视频移动端APP界面展示"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}